export let operations = [
	{ id:'smart',label:'smart' },
	{ id:'contains',label:'contains' },
	{ id:'!contains',label:'notContains' },
	{ id:'==',label:'equals' },
	{ id:'!=',label:'notEqual' },
	{ id:'starts with',label:'startsWith' },
	{ id:'ends with',label:'endsWith' },
];

import objGet from '../objGet';

// Address filter. Expects compare value to be an object.
// { name, postalCode, postalPlace, street, countryCode }

export function filterFactory(columnDef, op, ...compValues) {
	let compValue;
	let valueGetter;
	if (columnDef.valueGetter)
		valueGetter = columnDef.valueGetter;
	else
		valueGetter = (item) => objGet(item,columnDef.field);

	compValue = compValues[0].toLowerCase();

	switch (op) {
	case 'smart':
		return (item) => {
			let val = valueGetter(item);
			if (val && val.postalCode && !isNaN(compValue)) {
				return startsWith(val.postalCode, compValue);
			} else {
				if (!val) return false;
				let ret = true;
				for (let c of compValue.split(' ')) {
					ret = ret &&
						( contains(val.name, c)
						|| contains(val.postalCode, c)
						|| contains(val.postalPlace, c)
						|| contains(val.street, c) );
				}
				return ret;
			}
		};
	case '==':
		return (item) => {
			let val = valueGetter(item);
			return val && (equals(val.name, compValue)
				|| equals(val.postalCode, compValue)
				|| equals(val.postalPlace, compValue)
				|| equals(val.street, compValue));
		};
	case '!=':
		return (item) => {
			let val = valueGetter(item);
			return val && !equals(val.name, compValue)
				&& !equals(val.postalCode, compValue)
				&& !equals(val.postalPlace, compValue)
				&& !equals(val.street, compValue);
		};
	case 'contains':
		return (item) => {
			let val = valueGetter(item);
			return val && (contains(val.name, compValue)
				|| contains(val.postalCode, compValue)
				|| contains(val.postalPlace, compValue)
				|| contains(val.street, compValue));
		};
	case '!contains':
		return (item) => {
			let val = valueGetter(item);
			return val && !contains(val.name, compValue)
				&& !contains(val.postalCode, compValue)
				&& !contains(val.postalPlace, compValue)
				&& !contains(val.street, compValue);
		};
	case 'starts with':
		return (item) => {
			let val = valueGetter(item);
			return val && (startsWith(val.name, compValue)
				|| startsWith(val.postalCode, compValue)
				|| startsWith(val.postalPlace, compValue)
				|| startsWith(val.street, compValue));
		};
	case 'ends with':
		return (item) => {
			let val = valueGetter(item);
			return val && (endsWith(val.name, compValue)
				|| endsWith(val.postalCode, compValue)
				|| endsWith(val.postalPlace, compValue)
				|| endsWith(val.street, compValue));
		};
	default:
		throw new Error(`Unknown operation: ${  op}`);
	}


	function equals(val, compValue) {
		return val && val.toString().toLowerCase() === compValue;
	}
	function contains(val, compValue) {
		return val && val.toString().toLowerCase().indexOf(compValue) > -1;
	}
	function startsWith(val, compValue) {
		return val && val.toString().toLowerCase().startsWith(compValue);
	}
	function endsWith(val, compValue) {
		return val && val.toString().toLowerCase().endsWith(compValue);
	}
}